import { useEffect, useState } from "react";

import { useAnalyticsTracker } from "components/instrumentation/source/analytics";
import { useBootstrap } from "components/store/source";
import { useIntersect } from "components/ui/source";
import {
  Props,
  TripadvisorAwardBadge as TripadvisorAwardBadgePFC,
} from "components/ui/source/components/TripadvisorAwardBadge/TripadvisorAwardBadge";

export const TripadvisorAwardBadge = (props: Props) => {
  const { analytics } = useAnalyticsTracker();
  const {
    featureFlags: { tripadvisorBadgeEnabled },
  } = useBootstrap();

  const [target, status] = useIntersect({
    threshold: [0, 0.5, 0],
  });

  const [isExposed, setIsExposed] = useState(false);

  const flagValue = tripadvisorBadgeEnabled?.value;

  useEffect(() => {
    if (status?.isIntersecting && !isExposed) {
      analytics.track("$exposure", {
        flag_key: "tripadvisor-badge",
        variant: flagValue,
      });
      setIsExposed(true);
    }
  }, [status, analytics, flagValue, isExposed]);

  return (
    <div ref={target}>
      {!flagValue || flagValue === "disabled" ? null : (
        <TripadvisorAwardBadgePFC {...props} />
      )}
    </div>
  );
};
